(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tbso-product-description"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('[data-tbso-product-description]:not([data-ready])').forEach((wrapper) => {
        wrapper.dataset.ready = 'true';
        const content = wrapper.querySelector('[data-tbso-description-content]');
        const toggle = wrapper.querySelector('[data-tbso-description-toggle]');
        if (!content || !toggle) return;

        const collapsedHeight = 216;
        if (content.scrollHeight <= collapsedHeight + 8) return;

        content.classList.add('is-collapsed');
        toggle.hidden = false;
        toggle.addEventListener('click', () => {
          const willExpand = content.classList.contains('is-collapsed');
          content.classList.toggle('is-collapsed', !willExpand);
          toggle.setAttribute('aria-expanded', String(willExpand));
          toggle.textContent = willExpand ? toggle.dataset.hideLabel : toggle.dataset.showLabel;
          toggle.setAttribute('aria-label', toggle.textContent);
        });
      });
    };

    document.addEventListener('DOMContentLoaded', () => initialize());
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tbso-product-support"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('[data-tbso-product-support]:not([data-ready])').forEach((wrapper) => {
        wrapper.dataset.ready = 'true';
        const trigger = wrapper.querySelector('[data-tbso-share-open]');
        const popover = wrapper.querySelector('[data-tbso-share-popover]');
        const copy = wrapper.querySelector('[data-tbso-copy-link]');
        const status = wrapper.querySelector('[data-tbso-share-status]');
        if (!trigger || !popover || !copy || !status) return;

        trigger.addEventListener('click', async () => {
          const useNativeShare = window.matchMedia('(max-width: 749px)').matches && navigator.share;
          if (useNativeShare) {
            try {
              await navigator.share({ title: document.title, url: window.location.href });
              return;
            } catch (error) {
              if (error.name === 'AbortError') return;
            }
          }
          popover.hidden = !popover.hidden;
          trigger.setAttribute('aria-expanded', String(!popover.hidden));
          if (!popover.hidden) copy.focus();
        });

        copy.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(window.location.href);
            status.textContent = wrapper.dataset.linkCopied;
          } catch (error) {
            status.textContent = wrapper.dataset.shareError;
          }
        });

        document.addEventListener('click', (event) => {
          if (!wrapper.contains(event.target)) {
            popover.hidden = true;
            trigger.setAttribute('aria-expanded', 'false');
          }
        });

        wrapper.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && !popover.hidden) {
            popover.hidden = true;
            trigger.setAttribute('aria-expanded', 'false');
            trigger.focus();
          }
        });
      });
    };

    document.addEventListener('DOMContentLoaded', () => initialize());
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tbso-size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('[data-tbso-size-guide]:not([data-ready])').forEach((wrapper) => {
        wrapper.dataset.ready = 'true';
        const trigger = wrapper.querySelector('[data-tbso-size-guide-open]');
        const dialog = wrapper.querySelector('[data-tbso-size-guide-dialog]');
        const close = wrapper.querySelector('[data-tbso-size-guide-close]');
        if (!trigger || !dialog || !close) return;

        trigger.addEventListener('click', () => dialog.showModal());
        close.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        dialog.addEventListener('close', () => trigger.focus());
      });
    };

    document.addEventListener('DOMContentLoaded', () => initialize());
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
